import { selectFromProjectDto } from '../../models';

export default selectFromProjectDto()
  .id
  .organizationId
  .name
  .startDate
  .createdOn
  .toString();
